import { useState } from "react";
import { Modal } from "reactstrap";
import valve1 from './images/Valve1_Red.png'
import valve2 from './images/Valve2Red.png'
import dps from './images/DPS-OFF.png'
import fil from './images/Filtrationshiv.png'
import redupper from './images/red_vt_pump.png'
import FiltrationPopUp from "./FiltrationPopUp";
import ApiService from "../../services/apiService"
import { useEffect, useRef } from 'react';
import { toast } from "react-toastify";
import greenFilterPump from './images/greenFilterPump.png'
import yellowFilterPump from './images/yellowFilterPump.png'
import greyFilterPump from './images/greyFilterPump.png'

const Filtration = ({
    isOpen,
    onClose,
     container,
  }: {
    isOpen: boolean;
    onClose: () => void;
    style?: React.CSSProperties;
         container?: HTMLElement | null;
  }) =>{
   const targetRef = useRef<HTMLDivElement>(null);

        
    const[filteropen,setfilteropen] = useState(false)


    const fopen = () => setfilteropen(true)
    const fclose = () => setfilteropen(false) 

    const [filterpumpOpen, setfilterpumpOpen] = useState(false);
      const [selectedFilterPump, setselectedFilterPump] = useState<string | null>(null);


const [filterPumpData, setFilterPumpData] = useState([]);  
const getAllPumpingStations = async () => {
  try {
    const response = await ApiService.axiosApi(`/tags`, {
      method: 'GET'
    });

    if (response.success) {
       
     
      setFilterPumpData(response.data); 
       
    } else {
       console.log('Failed to fetch pumping stations');
    }

  } catch (error) {
    console.error('Error fetching pumping stations:', error);
     console.log('Error fetching pumping stations');
  }
};
useEffect(() => {
  getAllPumpingStations();

  // Move setInterval inside useEffect
  const interval = setInterval(() => {
    getAllPumpingStations();
  }, 5000); 

  // Cleanup interval on unmount
  return () => clearInterval(interval);
}, []); // keep dependency array



    const openFilterPump = (filterpumpName: string) => {
    setselectedFilterPump(filterpumpName);
    setfilterpumpOpen(true);
  };

  const closeFilterPump = () =>setfilterpumpOpen(false);

    return(
          <>
          
          <Modal isOpen={isOpen} size='xl' centered toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class"  >
          
         

          <div className="filtrationwrapper" ref={targetRef} >
            
        <div className="filtrationimg">

              
            <img src={fil} alt="" className="filtrationfinal" />
               
            <div>
            <div className='py-1 px-2'style={{
                  width:'100%',
                  height:'30px',
                  backgroundColor:'black',
                  position:"absolute",
                  top:'0%',
                  display:'flex',
                  justifyContent:'space-between',
                  color:'white'
               }}> 
                  <h5 style={{color:'white'}}>PRE FILTRATION SYSTEM</h5>
                   <button className="refreshButtonFiltration"
              onClick={getAllPumpingStations}
              style={{ cursor: "pointer" }}
            >
              &#x21bb;
            </button>
                  <button  className='closeButtonFiltration' onClick={onClose} style={{cursor:'pointer'}}>✖</button>
               </div>
    


          {["FLT1", "FLT2", "FLT3", "FLT4", "FLT5"].map((filterpumpName, idx) => {
  // Filter relevant tags for this pump
  const tags: { name: string; value: string }[] = filterPumpData.filter(
    (t: { name: string; value: string }) => t.name.startsWith(filterpumpName)
  );

  // Get individual tags
  const onTag = tags.find((t: any) => t.name === `${filterpumpName}_MTR_ON`);
  const tripTag = tags.find((t: any) => t.name === `${filterpumpName}_TP`);
  const offTag = tags.find((t: any) => t.name === `${filterpumpName}_MTR_OFF`);
 


let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenFilterPump
    : tripTag?.value === "True"
    ? yellowFilterPump
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redupper
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ? greyFilterPump
    : redupper; // default (if none matches)



  // Left positions for each valve
  const leftPositions = ["15.6%", "30.2%", "44.7%", "59.7%", "74.2%"];

  return (
     <div
        key={filterpumpName}
        style={{
          position: "absolute",
          top: "31%",
          left: leftPositions[idx],
          width: "30px",
          height: "35px",
          cursor: "pointer",
          zIndex: 10,
        }}
        onClick={() => openFilterPump(filterpumpName)}

      >
        <img
          src={imgSrc?imgSrc:redupper}
          alt={filterpumpName}
          style={{
            width: "100%",
            height: "100%",
            pointerEvents: "none", // ensures click passes to parent div
          }}
        />
      </div>
    );
  }
)}


    </div>
        </div>
        <div className="Valve-red1-filtration">
        <img src={valve1} alt="Valve1_Red1" className="redValve1-filtration" style={{
               
        }}/>
        <img src={valve1} alt="Valve1_Red2" className="redValve2-filtration"/>
        <img src={valve1} alt="Valve1_Red3" className="redValve3-filtration"/>
        <img src={valve1} alt="Valve1_Red4" className="redValve4-filtration"/>
        <img src={valve1} alt="Valve1_Red5" className="redValve5-filtration"/>
    </div>

   
    <div className="Valve-red2-filtration">
        <img src={valve2} alt="Valve1_Red1" className="redValve6-filtration"style={{
               left: '12.6%',
               top: '43.1%',
            }}/>
        <img src={valve2} alt="Valve1_Red2" className="redValve7-filtration"style={{
               left: '26.9%',
               top: '43.1%',
            }}/>
        <img src={valve2} alt="Valve1_Red3" className="redValve8-filtration"style={{
               left: '41.5%',
               top: '43.1%',
            }}/>
        <img src={valve2} alt="Valve1_Re54" className="redValve9-filtration"style={{
               left: '56.4%',
               top: '43.1%',
            }}/>
        <img src={valve2} alt="Valve1_Red2" className="redValve10-filtration"style={{
               left: '70.9%',
               top: '43.1%',
            }}/>
    </div>
    
    <div className="DPS-off-filtration">
        <img src={dps} alt="DPS-OFF1" className="DPS-OFF1-filtration" style={{
               left: '12.2%',
               top: '39.3%',
            }}/>
        <img src={dps} alt="DPS-OFF2" className="DPS-OFF2-filtration" style={{
               left: '26.6%',
               top: '39.3%',
            }}/>
        <img src={dps} alt="DPS-OFF3" className="DPS-OFF3-filtration" style={{
               left: '41.3%',
               top:'39.3%',
            }}/>
        <img src={dps} alt="DPS-OFF4" className="DPS-OFF4-filtration"style={{
               left: '56.2%',
               top: '39.3%',
            }}/>
        <img src={dps} alt="DPS-OFF5" className="DPS-OFF5-filtration" style={{
               left: '70.7%',
               top: '39.3%',
            }}/>
       
    </div>
         <FiltrationPopUp isOpen={filterpumpOpen} onClose={closeFilterPump}
         filterpumpName={selectedFilterPump || "FLT1_MTR_OFF"}
          container={targetRef.current}/>
  
    </div>
          </Modal>
           
          </>
    )
}

export default Filtration;